import { render, staticRenderFns } from "./AdjustPayGradeOrganisationApproval.vue?vue&type=template&id=170db88c"
import script from "./AdjustPayGradeOrganisationApproval.vue?vue&type=script&lang=js"
export * from "./AdjustPayGradeOrganisationApproval.vue?vue&type=script&lang=js"
import style0 from "./AdjustPayGradeOrganisationApproval.vue?vue&type=style&index=0&id=170db88c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports